module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/en-36d7d4ccf3acfbdd8b281b2eaa44e1d0.jpg";